import * as types from './types'
import * as actions from './actions'

function reducer (state = false, action) {
  switch (action.type) {
    case types.SHOW:
    case types.HIDE:
      return action.payload

    default:
      return state
  }
}

export default {
  actions,
  reducer,
}
